




























































































import { Component, Mixins } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import DataTable from "@monade/vue-components/src/components/VDataTable.vue";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import { Client } from "../../models";
import ClientsMixin from "../../mixins/http/ClientsMixin";
import { NoCache, RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import { currentUserStore } from "@/store/typed";
import Search from "@/components/VEntrySearch.vue";

@Component({ components: { Page, Search, DataTable, Paginator } })
export default class ClientList extends Mixins(ClientsMixin) {
  static readonly getClientsTag = "get_clients_tag";
  @RegisterHttp(ClientList.getClientsTag) getClientsRequest: RequestData;
  private items: Client[] = [];

  page = 1;
  search = null;

  get currentUser() {
    return currentUserStore.currentUser;
  }

  get columns() {
    let columns = [];

    columns.push({ name: "businessName", label: "BusinessName" });
    columns.push({ name: "name", label: "Name" });
    columns.push({ name: "address", label: "Address" });
    columns.push({ name: "contacts", label: "Contacts" });
    return columns;
  }

  mounted() {
    this.loadClients();
  }

  goToClient(item) {
    this.$router.push({
      name: "client_show",
      params: { id: item.id },
    });
  }

  onAdd() {
    this.$router.push({ name: "client_create" });
  }

  loadClients() {
    this.getClients(this.payload, ClientList.getClientsTag).then(
      (resp) => {
        this.items = resp;
      },
      (err) => {}
    );
  }

  onSearchCanceled() {
    this.page = 1;
    this.search = null;

    this.loadClients();
  }

  onSearched(items) {
    this.page = 1;
    this.items = items.items;
  }

  onPageChange(page) {
    this.page = page;
    this.loadClients();
  }

  // @NoCache
  get payload() {
    let data: any = {
      page: this.page,
      companyId: this.currentUser.company.id,
      filter: {},
    };

    if (this.search) {
      data.filter.term = this.search;
    }

    return data;
  }

  async searchClients(name: string) {
    if (name.trim().length > 0) {
      this.search = name;
      const products = await this.getClients(
        this.payload,
        ClientList.getClientsTag
      );
      return products;
    }
  }

  get loading() {
    return this.getClientsRequest?.loading;
  }

  get meta() {
    return this.getClientsRequest?.meta;
  }
}
